import { postChannelRule } from '../../services/api/channelRule.api';
import { POST_CHANNEL_RULE_REQUEST, POST_CHANNEL_RULE_SUCCESS, POST_CHANNEL_RULE_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[POST_CHANNEL_RULE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_CHANNEL_RULE_SUCCESS](state) {
			state.isLoading = false;
		},
		[POST_CHANNEL_RULE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async createChannelRule({ commit }, params = {}) {
			try {
				commit(POST_CHANNEL_RULE_REQUEST);
				await postChannelRule(params);
				commit(POST_CHANNEL_RULE_SUCCESS);
			} catch (error) {
				commit(POST_CHANNEL_RULE_FAILURE, error);
			}
		},
	},
};